import React from "react"
import { StaticQuery, graphql } from "gatsby"

import Footer from "./"

const FooterWrapper = (OriginalReactComponent) => {
  return class extends React.Component {
    render() {
      return (
        <StaticQuery
          query={graphql`
            query {
              allStoryblokEntry(
                filter: {
                  full_slug: {
                    eq: "hult/config/navigation-footer/central-footer"
                  }
                }
              ) {
                edges {
                  node {
                    uuid
                    content
                    slug
                  }
                }
              }
            }
          `}
          render={(data) => {
            let footer
            if (data && data.allStoryblokEntry) {
              data.allStoryblokEntry.edges.map((e) => {
                const block = JSON.parse(e.node.content)
                return (footer = (
                  <OriginalReactComponent path={this.props.path} blok={block} />
                ))
              })
            }
            return footer
          }}
        />
      )
    }
  }
}

export default FooterWrapper(Footer)
